import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core'
import {UserSessionService} from '../services/user-session.service';
import {Backend} from '@generated-backend-types';
import RoleEnum = Backend.App.Enums.Auth.RoleEnum;

@Directive({
  selector: '[appIfHasAnyRoles]',
  standalone: true
})
export class IfHasAnyRoleDirective {
  public constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly authService: UserSessionService
  ) {}

  @Input() set appIfHasAnyRoles(roles: RoleEnum[]) {
    if (roles && roles.length > 0 && this.authService.hasAnyRole(roles)) {
      this.viewContainer.createEmbeddedView(this.templateRef)
    } else {
      this.viewContainer.clear()
    }
  }
}
